import { combineReducers, legacy_createStore as createStore } from 'redux';
import channelsStore from './channel-reducer';
import { searchReducer } from './search-reducer';
import { purchaseSyncedReducer } from './purchase-synced-reducer';

const reducers = combineReducers({
    channelsStore,
    searchStore: searchReducer,
    purchaseSyncedStore: purchaseSyncedReducer,
});

export type RootState = ReturnType<typeof reducers>;
export const store = createStore(reducers);
export type AppDispatch = typeof store.dispatch;

export default reducers;
